module.exports = __webpack_public_path__ + "img/image-167.52b038d5.jpg";